/*
  BottomActions.jsx
*/

// Npm.
import React from 'react';

// Makes.
import { makeStyles, cx } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.space(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > .Button': {
      marginLeft: theme.space(1),
      flex: '0 0 auto',
    }
  },
}));

/**
 * Actions to display at the bottom of the dialog.
 * Just put here to re-use the styles.
 */
export default function BottomActions({ className, ...rest }) {

  const classes = useStyles();

  return (
    <div className={cx(classes.root, className)} {...rest} />
  );
}
